const CLASSIC_UI_KEY = 'focus-group-classic-ui';

/**
 * Whether this tab has opted out of the Labs focus-group experience.
 *
 * Scoped to the tab rather than the account: the opt-out exists so a researcher can finish a job in
 * the view they know when something here misbehaves, not so they can quietly stay on the old UI
 * forever. Closing the tab puts them back on the default.
 */
export const prefersClassicUi = (): boolean => sessionStorage.getItem(CLASSIC_UI_KEY) === 'true';

export const setPrefersClassicUi = ({ value }: { value: boolean }): void => {
  if (value) {
    sessionStorage.setItem(CLASSIC_UI_KEY, 'true');
  } else {
    sessionStorage.removeItem(CLASSIC_UI_KEY);
  }
};
